export const environment = {
  production: false,
  requireAccessCode: true,
  showLoginNotificationModal: false,
  apiUrl: "https://api-dev.amakalakara.com",
  ENCRYPTION_SECRET: "1d97fd15032fb5994b7985d4186b5ab1517a3c4514d158a9800884eba4e14554",
  HMAC_SECRET: "b6c8a29a0fbc51372d8a4e37512d7c04",
  googleMapsApiKey: "AIzaSyC6SW3RMQpATw2aAQyKpO6P_kzz1yvtbg0"
};
